export const FOOT_IN_INCHES = 12;
export const INCH_IN_CM = 2.54;
export const POUND_IN_KG = 0.453592;
export const CM_IN_FOOT = FOOT_IN_INCHES * INCH_IN_CM;

export const roundToOneDecimal = (value: number): number => {
  return Math.round(value * 10) / 10;
};

export const cmToInch = (cm: number | string): number => {
  const val = Number(cm);
  const inches = val / INCH_IN_CM;
  return roundToOneDecimal(inches);
};

export const inchesToCm = (inch: number): number => {
  return inch * INCH_IN_CM;
};

export const kgToPounds = (kgInput: number | string): number => {
  const kg = Number(kgInput);
  const pounds = kg / POUND_IN_KG;
  return roundToOneDecimal(pounds);
};

export const poundsToKg = (pounds: number): number => {
  return pounds * POUND_IN_KG;
};

export const cmToFeetAndInches = (
  value: number | string
): { feet: number; inches: number } => {
  const cm = Number(value);
  const inches = cmToInch(cm);
  const feet = Math.floor(inches / FOOT_IN_INCHES);
  const inchesLeft = Math.round(inches - feet * FOOT_IN_INCHES);

  if (inchesLeft === 12) {
    return { feet: feet + 1, inches: 0 };
  }

  return { feet, inches: inchesLeft };
};
